import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  FormControl,
  FormLabel,
  Text,
  Switch,
  useToast,
} from '@chakra-ui/react';
import FaqApi from 'api/faq';
import SelectField from 'components/formComponents/selectField';
import InputField from 'components/formComponents/inputField';
import { FaqValidationSchema } from 'formValidations/faqFormValidations';
import BankAccountApi from 'api/bankaccounts';
import IfscApi from 'api/ifsc';

const PopModal = (props) => {
  const userId = props.userId;
  const toast = useToast();
  const toastIdRef = React.useRef();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const [inpDisable, setInpDisable] = useState(true);

  const initialValues = {
    accountNumber: '',
    holderName: '',
    ifsc: '',
    bankName: '',
    bankBranch: '',
    accountType: 'SAVING',
    default: false,
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    console.log('values here are - ', values);
    try {
      let response = await BankAccountApi.Create({
        ...values,
        userId,
      });
      response = response.data;
      if (response.status_code === 200) {
        toast({
          title: response?.data?.message || 'Successfully Added',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
        onClose();
        props.func();
      } else {
        toast({
          title: response?.data?.message || 'Error Adding',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (error) {
      toast({
        title: 'Unable to Add',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
      console.log(error);
    } finally {
      setSubmitting(false);
    }
  };

  const GetIfsc = async (e, setFieldValue) => {
    console.log('GetIfsc called', e);

    try {
      let response = await IfscApi.Get({ ifsc: e });
      response = response.data;
      console.log(response);
      if (response.status_code === 200) {
        setFieldValue('bankName', response.data.bank);
        setFieldValue('bankBranch', response.data.branch);
        setInpDisable(false);
      } else {
        toastIdRef.current = toast({
          title: 'Bank name and Branch not found, please fill manually',
          status: 'warning',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
        setInpDisable(false);
      }
    } catch (error) {
      console.log('Here is Error', error);
      setInpDisable(false);
    }
  };

  return (
    <>
      <Button
        variant='lightBrand'
        fontSize='sm'
        fontWeight='500'
        borderRadius='10px'
        boxShadow='lg'
        px='15px'
        py='5px'
        disabled={props.disabled}
        onClick={onOpen}>
        {props.Icon}
      </Button>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{props.head}</ModalHeader>
          <ModalCloseButton />
          <Formik
            initialValues={initialValues}
            // validationSchema={FaqValidationSchema}
            onSubmit={handleSubmit}>
            {({ setFieldValue, isSubmitting }) => (
              <Form noValidate>
                <ModalBody pb={6}>
                  <InputField
                    label='Account Number'
                    name='accountNumber'
                    type='number'
                    required
                  />
                  <InputField
                    label='Holder Name'
                    name='holderName'
                    type='text'
                    required
                  />
                  <InputField
                    label='IFSC Code'
                    name='ifsc'
                    type='text'
                    onChange={(e) => {
                      setFieldValue('ifsc', e.target.value);
                      e.target.value.length === 11 &&
                        GetIfsc(e.target.value, setFieldValue);
                    }}
                    required
                  />
                  <InputField
                    label='Bank Name'
                    name='bankName'
                    type='text'
                    variant='auth'
                    bgColor={inpDisable ? 'gray.200' : ''}
                    disabled={inpDisable}
                    required
                  />
                  <InputField
                    label='Bank Branch'
                    name='bankBranch'
                    type='text'
                    variant='auth'
                    bgColor={inpDisable ? 'gray.200' : ''}
                    disabled={inpDisable}
                    required
                  />
                  <SelectField
                    label='Account Type'
                    name='accountType'
                    options={[
                      { value: 'SAVING', label: 'Savings Account' },
                      { value: 'CURRENT', label: 'Current Account' },
                    ]}
                  />
                  <FormControl
                    mt={8}
                    display='flex'
                    align='center'>
                    <FormLabel>
                      <Text
                        fontSize='md'
                        fontWeight='50'>
                        Use as Default Account
                      </Text>
                    </FormLabel>
                    <Switch
                      mt={1}
                      id='default'
                      onChange={(e) =>
                        setFieldValue('default', e.target.checked)
                      }
                    />
                  </FormControl>
                </ModalBody>
                <ModalFooter>
                  <Button
                    colorScheme='blue'
                    mr={3}
                    type='submit'
                    isLoading={isSubmitting}>
                    Add Account
                  </Button>
                  <Button onClick={onClose}>Cancel</Button>
                </ModalFooter>
              </Form>
            )}
          </Formik>
        </ModalContent>
      </Modal>
    </>
  );
};

export default PopModal;
